import { render } from "./NuevoProyectoGPT.vue?vue&type=template&id=7a0de63b"
import script from "./NuevoProyectoGPT.vue?vue&type=script&lang=js"
export * from "./NuevoProyectoGPT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__